const validateHideConditionArray = (field, fieldsValues) => {
  // case OR
  if (field.hideCondition?.type === 'or') {
    for (const indexField in field.hideCondition.parentField) {
      if (field.hideCondition?.parentValue[indexField]?.includes(
        fieldsValues[field.hideCondition?.parentField[indexField]] ?? ''
      )) {
        return true;
      }
    }
    return false;
  }

  // case AND
  let hideField = true

  for (const indexField in field.hideCondition.parentField) {
    if(!field.hideCondition?.parentValue[indexField].includes(
      fieldsValues[field.hideCondition?.parentField[indexField]] ?? ''
    )){
      hideField = false
      break;
    }
  }

  return hideField
}

export const validateHideCondition = (field, fieldsValues) => {
  return field.hideCondition ? (field.hideCondition.notInclude ? 
    !(fieldsValues[field.hideCondition?.parentField] ?? '')
      .split(',').map(v => v.trim())?.includes(
        field.hideCondition?.notInclude
      )
    : Array.isArray(field.hideCondition.parentField) ? validateHideConditionArray(field, fieldsValues) : (
      field.hideCondition?.parentValue.includes(
        fieldsValues[field.hideCondition?.parentField] ?? ''
      )
    ) 
  ) : false
}

